import { render, staticRenderFns } from "./InitialInvestment.vue?vue&type=template&id=56cc4bcd&"
import script from "./InitialInvestment.vue?vue&type=script&lang=js&"
export * from "./InitialInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports